export const enum StoryTellingDescriptionPositionEnum {
  BEFORE_VISUAL = 'Description before Visual',
  AFTER_VISUAL = 'Description after Visual'
}

export type StoryTellingDescriptionPosition = `${StoryTellingDescriptionPositionEnum}`;

export const enum StoryTellingDescriptionPositionTransformedEnum {
  BEFORE = 'before',
  AFTER = 'after'
}

export type StoryTellingDescriptionPositionTransformed = `${StoryTellingDescriptionPositionTransformedEnum}`;
